import angular from 'angular'
import moment from 'moment-timezone'
import Chart from 'chart.js/auto'

angular.module('admin.all_sales').controller('UserAnalyticsCtrl', UserAnalyticsCtrl)

/** @ngInject */
function UserAnalyticsCtrl($scope, AllSalesService) {
  var vm = this
  vm.parent = $scope.$parent.vm

  vm.timeframe = '1_month'
  vm.channels = []
  vm.loading = false
  vm.data = { demographics: {}, purchase_count: {}, active_users: {} }

  let lineChart, barChart, pieChart, campaignChart

  vm.load = function () {
    vm.loading = true
    AllSalesService.getAnalytics(vm.timeframe, vm.channels)
      .then(function (res) {
        vm.data = res.result
        setTimeout(initCharts, 0)
      })
      .finally(function () {
        vm.loading = false
      })
  }

  vm.changeTimeframe = function (range) {
    vm.timeframe = range
    vm.load()
  }

  vm.resetFilters = function () {
    vm.channels = []
    vm.load()
  }

  function initCharts() {
    if (lineChart) lineChart.destroy()
    if (barChart) barChart.destroy()
    if (pieChart) pieChart.destroy()
    if (campaignChart) campaignChart.destroy()

    const data = vm.data || {}

    const ctxLine = document.getElementById('lineChart')
    if (ctxLine && data.active_users && data.active_users.graph) {
      const labels = data.active_users.graph
        .map((item) => {
          const format = vm.timeframe === 'all' ? 'MMM YYYY' : 'MMM DD'
          return moment.parseZone(item.XAxis).format(format)
        })
        .reverse()
      const values = data.active_users.graph.map((item) => item.YAxis).reverse()

      lineChart = new Chart(ctxLine, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Users',
              data: values,
              fill: true,
              borderColor: '#3498db',
              backgroundColor: 'rgba(52, 152, 219, 0.4)',
              tension: 0.4,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { display: false } },
            y: { grid: { color: '#e2e8f0' }, beginAtZero: true },
          },
        },
      })
    }

    const ctxBar = document.getElementById('barChart')
    if (ctxBar && data.purchase_count) {
      barChart = new Chart(ctxBar, {
        type: 'bar',
        data: {
          labels: ['Bought', 'Claimed', 'Both'],
          datasets: [
            {
              label: 'Actions',
              data: [
                data.purchase_count.paid || 0,
                data.purchase_count.free || 0,
                data.purchase_count.both || 0,
              ],
              backgroundColor: ['#e74c3c', '#f1c40f', '#2ecc71'],
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            x: { grid: { display: false } },
            y: { grid: { color: '#e2e8f0' }, beginAtZero: true },
          },
        },
      })
    }

    const ctxPie = document.getElementById('pieChart')
    if (ctxPie && data.demographics) {
      const d13 = data.demographics['13-17'] ? data.demographics['13-17'].count : 0
      const d18 = data.demographics['18-24'] ? data.demographics['18-24'].count : 0
      const d25 = data.demographics['25-34'] ? data.demographics['25-34'].count : 0
      const d35 = data.demographics['35-49'] ? data.demographics['35-49'].count : 0
      const d50 = data.demographics['50+'] ? data.demographics['50+'].count : 0

      pieChart = new Chart(ctxPie, {
        type: 'pie',
        data: {
          labels: ['13-17', '18-24', '25-34', '35-49', '50+'],
          datasets: [
            {
              data: [d13, d18, d25, d35, d50],
              backgroundColor: ['#e74c3c', '#f1c40f', '#2ecc71', '#3498db', '#9b59b6'],
              borderWidth: 2,
              borderColor: '#ffffff',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
        },
      })
    }

    const ctxCampaign = document.getElementById('campaignChart')
    if (ctxCampaign && data.participation) {
      // Map labels and values for the chart
      const participationData = data.participation
      const labels = participationData.map((p) => p.ChannelName)
      const values = participationData.map((p) => p.Count)

      const colors = [
        '#6366f1',
        '#10b981',
        '#f59e0b',
        '#ef4444',
        '#8b5cf6',
        '#ec4899',
        '#06b6d4',
        '#f97316',
        '#14b8a6',
        '#a855f7',
        '#fbbf24',
        '#1d4ed8',
        '#047857',
        '#b91c1c',
        '#4f46e5',
        '#7c3aed',
        '#db2777',
        '#ea580c',
        '#0891b2',
        '#0d9488',
        '#2563eb',
        '#9333ea',
      ]

      campaignChart = new Chart(ctxCampaign, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [{ label: 'Users', data: values, backgroundColor: colors }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          plugins: {
            legend: { display: false },
            tooltip: {
              callbacks: {
                title: function (items) {
                  return labels[items[0].dataIndex]
                },
              },
            },
          },
          scales: {
            x: { beginAtZero: true, grid: { color: '#e2e8f0' } },
            y: {
              grid: { display: false },
              ticks: {
                callback: function (value, index) {
                  const label = labels[index]
                  if (!label) return ''
                  const words = label.split(' ')
                  if (words.length > 2) {
                    return words.slice(0, 2).join(' ') + '...'
                  }
                  return label
                },
              },
            },
          },
        },
      })
    }
  }

  vm.exportFormat = 'xlsx'
  vm.exportLoading = false

  vm.openExportModal = function () {
    $('#exportAnalyticsModal').modal('show')
  }

  vm.export = function () {
    vm.exportLoading = true
    AllSalesService.exportAnalytics(vm.timeframe, vm.channels, vm.exportFormat)
      .then(function (response) {
        $('#exportAnalyticsModal').modal('hide')
        if (response && response.data) {
          const headers = response.headers()
          console.log('All headers:', headers)

          let disposition =
            response.headers('content-disposition') || response.headers('Content-Disposition')
          if (!disposition && headers) {
            disposition = headers['content-disposition'] || headers['Content-Disposition']
          }

          // Fallback filename if header is missing
          let dateStr = moment().format('YYYY-MM-DD')
          let filename = 'user_analytics_' + dateStr + '.' + vm.exportFormat

          if (disposition && disposition.indexOf('attachment') !== -1) {
            const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }

          // Create blob from arraybuffer
          const blob = new Blob([response.data], {
            type:
              response.headers('content-type') ||
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()

          setTimeout(function () {
            window.URL.revokeObjectURL(url)
            document.body.removeChild(link)
          }, 100)
        }
      })
      .catch(function (err) {
        console.error('Export failed', err)
        swal('Export Error', 'Failed to export analytics. Please try again.', 'error')
      })
      .finally(function () {
        vm.exportLoading = false
        if ($scope.$$phase !== '$apply' && $scope.$$phase !== '$digest') {
          $scope.$apply()
        }
      })
  }

  vm.load()
}
